"use client";

import React from "react";
import { useTranslation } from "react-i18next";

const ContactHero: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { t } = useTranslation();
  return (
    <section className="bg-[url('/images/request_demo_bg.webp')] bg-cover bg-center min-h-[600px] py-16 font-sans">
      <div className="container mx-auto px-4">
        <div className="max-w-5xl mx-auto">
          <h1 className="text-5xl font-bold text-white">
            {t("requestDemo.title")}
          </h1>
          <p className="text-xl text-white mb-8">
            {t("requestDemo.description")}
          </p>

          {children}
        </div>
      </div>
    </section>
  );
};

export default ContactHero;
